import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthContext } from '_technical/contexts/AuthContext';
import { Role } from '_business/types/User';

interface Props {
  children: React.ReactNode;
  roles?: (Role | '*')[];
}

function AuthGuard(props: Props) {
  const { children } = props;

  const { auth } = useAuthContext();
  if (!auth?.token) {
    return <Redirect to="/connexion" />;
  }

  if (props.roles?.includes('*') || props.roles?.includes(auth.user.role)) {
    return children;
  }

  if (auth.user.role === Role.PARTNER) {
    return <Redirect to="/clients" />;
  }
  return <Redirect to="/" />;
}

export default AuthGuard;
